import InvitationsCard from "@features/auth/components/InvitationsCard/InvitationsCard";
import JoinOrganizationsCard from "@features/auth/components/JoinOrganizationsCard/JoinOrganizarionsCard";
import { AppModeSelector } from "@shared/ui";
import { LoadingPage } from "@shared/ui";
import { NotYetPlannedPage } from "@shared/ui";
import { ProtectedRoute } from "@shared/ui";
import UserCompliancePage from "@features/user/pages/compliance/components/UserCompliancePage";
import UserProfile from "@features/user/pages/profile/components/UserProfile";
import { QESPage } from "@features/user/pages/qes/components/QESPage";
import SecurityPage from "@features/user/pages/security/components/SecurityPage";
import TeamsAccess from "@features/user/pages/teamsAccess/components/TeamsAccess";
import UserWrapper from "@features/user/components/UserWrapper";
import { ROOTS, USER_ROUTES } from "@app/config/constants";
import { lazy, Suspense } from "react";
import { Navigate, Route } from "react-router-dom";

const Questionnaire = lazy(() => import("@shared/ui/Questionnaires"));

export default function getUserRoutes() {
  return (
    <Route
      path={`${ROOTS.USER}`}
      element={
        <ProtectedRoute>
          <UserWrapper />
        </ProtectedRoute>
      }
    >
      <Route index element={<Navigate to={USER_ROUTES.PROFILE} replace />} />
      <Route
        path={USER_ROUTES.QUESTIONNAIRE}
        element={
          <Suspense fallback={<LoadingPage />}>
            <ProtectedRoute>
              <Questionnaire />
            </ProtectedRoute>
          </Suspense>
        }
      />
      <Route
        path={USER_ROUTES.INVITES}
        element={
          <Suspense fallback={<LoadingPage />}>
            <ProtectedRoute>
              <InvitationsCard />
            </ProtectedRoute>
          </Suspense>
        }
      />
      <Route
        path={USER_ROUTES.AUTOJOIN}
        element={
          <Suspense fallback={<LoadingPage />}>
            <ProtectedRoute>
              <JoinOrganizationsCard />
            </ProtectedRoute>
          </Suspense>
        }
      />
      <Route
        path={USER_ROUTES.PROFILE}
        element={
          <ProtectedRoute>
            <UserProfile />
          </ProtectedRoute>
        }
      />
      <Route
        path={USER_ROUTES.CALENDER}
        element={
          <ProtectedRoute>
            <NotYetPlannedPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={USER_ROUTES.SECURITY}
        element={
          <ProtectedRoute>
            <SecurityPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={USER_ROUTES.COMPLIANCE}
        element={
          <ProtectedRoute>
            <UserCompliancePage />
          </ProtectedRoute>
        }
      />
      <Route
        path={USER_ROUTES.TEAMACCESS}
        element={
          <ProtectedRoute>
            <TeamsAccess />
          </ProtectedRoute>
        }
      />
      <Route
        path={USER_ROUTES.QES}
        element={
          <ProtectedRoute>
            <QESPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<AppModeSelector />} />
    </Route>
  );
}
